import React from 'react';
export const Hero = () => {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing');
    pricingSection?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-navy text-cream py-8 md:py-16 px-6 md:px-10" data-id="element-148">
      <div className="max-w-5xl mx-auto" data-id="element-149">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-10" data-id="element-150">
          <div className="md:w-1/2" data-id="element-151">
            <p className="text-xl md:text-2xl mb-6" data-id="element-152">
              Para la mujer latina que sostiene a todos… pero nadie la sostiene
              a ella.
            </p>
            <p className="serif-text text-lg mb-8" data-id="element-153">
              "Mijita… organícese bien." Eso te lo dijeron toda la vida. Tu
              mamá, tu abuela, tu tía. Todas con la chancla levantada como si
              eso pudiera arreglar cuentas atrasadas, pagos que no esperan,
              remesas y quincenas que se evaporan en un segundo.
            </p>
            <p className="text-xl font-semibold mb-8" data-id="element-154">
              Pero la verdad es que nadie te enseñó cómo hacerlo.
            </p>
            <button onClick={scrollToPricing} className="btn-primary text-lg" data-id="element-155">
              Descubre Cómo
            </button>
          </div>
          <div className="md:w-1/2 flex justify-center" data-id="element-156">
            <div className="bg-white p-4 rounded-lg" data-id="element-157">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/xtXoSPSem7dKSR4E5bQZMf/ChatGPT_Image_Nov_20%2C_2025%2C_05_49_45_PM.png" alt="¿Dónde se va mi dinero? - Guía financiera para mujeres latinas" className="w-full max-w-md shadow-2xl transform hover:scale-105 transition-transform duration-300" data-id="element-158" />
            </div>
          </div>
        </div>
      </div>
    </section>;
};